import WebCADConfig from './WebCADConfig';

export {
  WebCADConfig,
};
